import React from 'react';
import CartPage from 'rev.sdk.js/Templates/CartPage';
import {Button, Image, message} from 'antd';

const EmptyCart = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 50,
      width: '100%',
      height: '100%',
    }}>
    <img
      src="/images/empty-bag-2.png"
      width="200"
      style={{width: '60%', maxWidth: 500, minWidth: 250}}
    />
    <h4 style={{marginTop: 20, color: '#BAD754'}}>購物車尚無商品</h4>
    <a style={{marginTop: 20, fontSize: 20, color: '#F4C41C'}} href="/products">
      點擊此處立刻購物去
    </a>
  </div>
);

function Cart(props) {
  const renderCustomComponent = (props) => {
    const isAdmin = window.location.pathname.indexOf('admin') > -1;
    const {name, data} = props;

    if (name === 'CART_CUSTOM_COLUMN') {
      if (data.item.product.labels?.includes('custom')) {
        return (
          <div>
            <div>
              <Image
                style={{minWidth: 200}}
                src={data.item.config.extra_data.image || ''}
                fallback="https://www.taiwang-puzzle.com/image/cache/catalog/%E5%AE%A2%E8%A3%BD%E8%B4%88%E7%A6%AE%E5%93%81%E6%8B%BC%E5%9C%96/cp-0020-500x500.jpg"
              />
              {isAdmin && (
                <Button
                  style={{width: '100%'}}
                  onClick={async () => {
                    try {
                      const image = await fetch(
                        data.item.config.extra_data.image,
                      );
                      const imageBlog = await image.blob();
                      const imageURL = URL.createObjectURL(imageBlog);
                      const link = document.createElement('a');
                      link.href = imageURL;
                      link.download = 'image';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    } catch (e) {
                      message.error('下載失敗，請稍後重新嘗試。');
                    } finally {
                      message.success('下載成功，下載進行中。');
                    }
                  }}>
                  下載
                </Button>
              )}
            </div>
          </div>
        );
      } else {
        return null;
      }
    }
    return null;
  };

  return (
    <CartPage
      {...props}
      renderCartEmpty={() => <EmptyCart />}
      renderCustomComponent={renderCustomComponent}
    />
  );
}

export default Cart;
